import { ModuleWithProviders, NgModule } from '@angular/core';
import { DatatableComponent } from './components/datatable/datatable.component';
import { DatatableLayoutComponent } from './components/datatable-layout/datatable-layout.component';
import { DataTablesModule as AngularDatatablesModule } from 'angular-datatables';
import { SupportModule } from '../support/support.module';
import { FormsModule } from '../forms/forms.module';
import { DatatableQueryService } from './services/datatable-query.service';

@NgModule({
    imports: [SupportModule, AngularDatatablesModule, FormsModule],
    exports: [DatatableComponent, DatatableLayoutComponent, AngularDatatablesModule],
    declarations: [DatatableComponent, DatatableLayoutComponent],
    providers: [],
})
export class DatatablesModule {

    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: DatatablesModule,
            providers: [
                DatatableQueryService
            ]
        }
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/datatables/datatables.module.ts